import { HTMLAttributes } from "react";

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const Skeleton = ({ className = "", ...props }: SkeletonProps) => {
  return (
    <div
      className={`animate-pulse bg-surface-elevated/70 rounded-md ${className}`}
      {...props}
    />
  );
};

export const SkeletonText = ({
  lines = 1,
  className = "w-full h-4",
}: {
  lines?: number;
  className?: string;
}) => {
  return (
    <div className="space-y-2 w-full">
      {Array.from({ length: lines }).map((_, idx) => (
        <Skeleton
          key={idx}
          className={`${className} ${
            idx === lines - 1 && lines > 1 ? "w-2/3" : "w-full"
          }`}
        />
      ))}
    </div>
  );
};

export const SkeletonCard = ({ className = "" }: { className?: string }) => {
  return (
    <div
      className={`bg-surface border border-border p-6 rounded-xl space-y-4 shadow-synaptix-card ${className}`}
    >
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-1/3" />
        <Skeleton className="h-4 w-16" />
      </div>
      <SkeletonText lines={3} />
      <div className="pt-2 flex justify-end gap-2">
        <Skeleton className="h-9 w-20 rounded-lg" />
        <Skeleton className="h-9 w-24 rounded-lg" />
      </div>
    </div>
  );
};

export const SkeletonTable = ({
  rows = 5,
  columns = 4,
}: {
  rows?: number;
  columns?: number;
}) => {
  return (
    <div className="w-full space-y-3">
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div
          key={rowIdx}
          className="flex items-center justify-between gap-4 py-3 px-4 bg-surface/50 rounded-lg border border-border/50"
        >
          {Array.from({ length: columns }).map((_, colIdx) => (
            <Skeleton
              key={colIdx}
              className={`h-4 ${colIdx === 0 ? "w-1/4" : "w-1/6"}`}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
